import {ZeroNeetSurveySlug} from './types';

// question10, 6-row matrix on survey 500 ("actual" / aggiornamento)
const FUNNEL_KEYS_500 = {
    informati: 'question10_che_avete_informato_riguardo_alle_opportunita_offerte_dal_progetto_numero',
    interesse: 'question10_dai_quali_avete_ricevuto_una_manifestazione_di_interesse_verso_il_progetto_numero',
    aderito: 'question10_in_possesso_dei_requisiti_richiesti_dal_bando_che_hanno_aderito_al_progetto_firmando_il_documento_di_adesione_numero',
    coinvolti: 'question10_che_avete_coinvolto_in_una_o_piu_delle_attivita_previste_ai_fini_dellattivazione_numero',
    lavoro: 'question10_che_avete_inserito_nel_mercato_del_lavoro_con_contratto_di_tirocinio_o_contratto_di_lavoro_di_durata_a_6_mesi_full_time_o_part_time_non_inferiore_a_20_ore_settimanali_numero',
    studi: 'question10_che_hanno_ripreso_gli_studi_per_il_conseguimento_del_diploma_di_scuola_secondaria_di_primo_o_di_secondo_grado_o_della_qualifica_professionale_numero',
};

// question8, 6-row matrix on survey 499 ("expected" / previsionale)
const FUNNEL_KEYS_499 = {
    p_lavoro: 'question8_che_prevedete_di_inserire_nel_mercato_del_lavoro_con_contratto_di_tirocinio_o_contratto_di_lavoro_di_durata_a_6_mesi_full_time_o_part_time_non_inferiore_a_20_ore_settimanali_numero',
    p_studi: 'question8_che_prevedete_riprenderanno_gli_studi_per_il_conseguimento_del_diploma_di_scuola_secondaria_di_primo_o_di_secondo_grado_o_della_qualifica_professionale_numero',
};

// 12-row reach/sensibilizzazione matrix, survey 499 (question3) — "attesi"
const ATTESI_SENS_499 = [
    'question3_genitori_eo_altri_familiari_dei_neet_numero',
    'question3_vicini_di_casa_dei_neet_numero',
    'question3_coetanei_eo_amici_dei_neet_numero',
    'question3_operatori_delle_scuole_numero',
    'question3_altri_educatori_numero',
    'question3_operatori_dei_servizi_sociali_numero',
    'question3_operatori_dei_servizi_sanitari_specialistici_psichiatricipsicologici_numero',
    'question3_operatori_di_altri_servizi_sanitari_numero',
    'question3_sacerdoti_e_personale_laico_di_parrocchie_e_oratori_numero',
    'question3_allenatori_eo_dirigenti_di_societa_sportive_numero',
    'question3_commercianti_numero',
    'question3_altra_categoria_numero',
];

// 11-row equivalent on survey 500 (question3) — "effettivi" (no "Commercianti" row)
const EFFETTIVI_SENS_500 = [
    'question3_genitori_eo_altri_familiari_dei_neet_numero',
    'question3_vicini_di_casa_dei_neet_numero',
    'question3_coetanei_eo_amici_dei_neet_numero',
    'question3_operatori_delle_scuole_numero',
    'question3_altri_educatori_numero',
    'question3_operatori_dei_servizi_sociali_numero',
    'question3_operatori_dei_servizi_sanitari_specialistici_psichiatricipsicologici_numero',
    'question3_operatori_di_altri_servizi_sanitari_numero',
    'question3_sacerdoti_e_personale_laico_di_parrocchie_e_oratori_numero',
    'question3_allenatori_eo_dirigenti_di_societa_sportive_numero',
    'question3_altra_categoria_numero',
];

// Domanda6, 3-row matrix on survey 504 (legal-form breakdown)
const ENTI_KEYS_504 = {
    pub: 'domanda6_numero_di_enti_pubblici_che_si_prevede_di_coinvolgere_numero_enti',
    np: 'domanda6_numero_di_enti_privati_non_profit_che_si_prevede_di_coinvolgere_numero_enti',
    fp: 'domanda6_numero_di_enti_privati_for_profit_che_si_prevede_di_coinvolgere_numero_enti',
};

// Tooltip mirrors indicator 1.6.A's wording (and the survey-500 field actually queried by
// FUNNEL_KEYS_500.lavoro: "...contratto di tirocinio o contratto di lavoro di durata ≥ a 6 mesi...").
// The guideline PDF's section-VI descriptive bullet instead says "...tirocinio di durata ≥ a 6 mesi
// o contratto di lavoro di durata ≥ a 4 mesi..." — a wording mismatch against its own indicator
// text and the underlying survey field, which the tooltip intentionally does not reproduce.
const DASHBOARD1_SECTION_VI_TOOLTIP =
    "Il grafico mostra il tasso di (re)inserimento formativo o lavorativo dei beneficiari, complessivo e per ciascuna delle tipologie di attivazione (inserimento nel mercato del lavoro e ripresa degli studi), per il vostro progetto a confronto con la media degli stessi valori in tutti i progetti. I valori sono ottenuti rispettivamente dal rapporto tra: i giovani NEET inseriti nel mercato del lavoro (con contratto di tirocinio o contratto di lavoro di durata ≥ a 6 mesi, full time o part-time non inferiore a 20 ore settimanali) e i giovani NEET coinvolti in una o più delle attività previste ai fini dell'attivazione, secondo la più recente scheda aggiornamento attività di intercettazione; i giovani NEET che hanno ripreso gli studi (per il conseguimento del diploma di scuola secondaria di primo o di secondo grado o della qualifica professionale) e i giovani NEET coinvolti in una o più delle attività previste ai fini dell'attivazione, secondo la più recente scheda aggiornamento attività di intercettazione.";

const DASHBOARD1_SECTION_VII_TOOLTIP =
    "Il grafico mostra il tasso di (re)inserimento formativo/lavorativo dei beneficiari rispetto alle previsioni, complessivo e per ciascuna delle tipologie di attivazione (inserimento nel mercato del lavoro e ripresa degli studi), per il vostro progetto a confronto con la media degli stessi valori in tutti i progetti. I valori sono ottenuti rispettivamente dal rapporto tra: i giovani NEET inseriti nel mercato del lavoro (con contratto di tirocinio o contratto di lavoro di durata ≥ a 6 mesi, full time o part-time non inferiore a 20 ore settimanali), secondo la più recente scheda di aggiornamento attività di intercettazione, e i giovani NEET che si prevedeva di inserire nel mercato del lavoro, secondo la scheda previsionale attività di intercettazione; i giovani NEET che hanno ripreso gli studi (per il conseguimento del diploma di scuola secondaria di primo o di secondo grado o della qualifica professionale), secondo la più recente scheda di aggiornamento attività di intercettazione, e i giovani NEET che si prevedeva avrebbero ripreso gli studi, secondo la scheda previsionale attività di intercettazione.";

export const FINALITA = {
    casi: 'Confronto sui singoli casi/percorsi',
    sistema: 'Confronto sul sistema di risposta',
} as const;

export const buildDashboard1Slugs = (survey499: number, survey500: number): ZeroNeetSurveySlug[] => [
    {
        key: 'ind_1_1',
        roman: '1.1',
        title: 'TASSO DI RAGGIUNGIMENTO DEI DESTINATARI DELLE ATTIVITÀ DI SENSIBILIZZAZIONE',
        tooltip:
            'Il grafico mostra il tasso di raggiungimento dei destinatari attesi a seguito delle attività di sensibilizzazione previste dal vostro progetto a confronto con la media dello stesso valore in tutti i progetti. Il valore è ottenuto dal rapporto tra i destinatari che il progetto prevede di raggiungere secondo la scheda previsionale attività di intercettazione e i soggetti effettivamente raggiunti secondo la più recente scheda aggiornamento attività di intercettazione.',
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: EFFETTIVI_SENS_500},
        denominator: {survey_id: survey499, question: ATTESI_SENS_499},
    },
    {
        key: 'ind_1_2',
        roman: '1.2',
        title: 'CAPACITÀ DI INGAGGIO DEI NEET',
        tooltip:
            'Il grafico mostra la capacità di ingaggio dei giovani NEET per il proprio progetto a confronto con la media dello stesso valore in tutti i progetti. Il valore è ottenuto dal rapporto tra i giovani che hanno presentato una "manifestazione di interesse" verso il progetto, secondo la più recente scheda di aggiornamento attività di intercettazione e i giovani NEET che sono stati informati delle opportunità offerte dal progetto, secondo la stessa scheda.',
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.interesse},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.informati},
    },
    {
        key: 'ind_1_3',
        roman: '1.3',
        title: 'TASSO DI ADESIONE AL PERCORSO',
        tooltip:
            'Il grafico mostra il tasso di adesione al percorso da parte dei giovani NEET per il proprio progetto a confronto con la media dello stesso valore in tutti i progetti. Il valore è ottenuto dal rapporto tra i giovani in possesso dei requisiti richiesti dal bando che hanno aderito al progetto (firmando il documento di adesione), secondo la più recente scheda di aggiornamento attività di intercettazione e i giovani NEET dai quali è stata ricevuta una "manifestazione di interesse" verso il progetto, secondo la stessa scheda.',
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.aderito},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.interesse},
    },
    {
        key: 'ind_1_4',
        roman: '1.4',
        title: 'TASSO DI AVVIO DEI PERCORSI',
        tooltip:
            "Il grafico mostra il tasso di avvio dei percorsi previsti ai fini dell'attivazione dei giovani NEET per il vostro progetto a confronto con la media dello stesso valore in tutti i progetti. Il valore è ottenuto dal rapporto tra i giovani coinvolti in una o più delle attività previste ai fini dell'attivazione, secondo la più recente scheda di aggiornamento attività di intercettazione e i giovani in possesso dei requisiti richiesti dal bando che hanno aderito al progetto, firmando il documento di adesione, secondo la stessa scheda.",
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.coinvolti},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.aderito},
    },
    {
        key: 'ind_1_5',
        roman: '1.5',
        title: 'TASSO DI (RE)INSERIMENTO LAVORATIVO/FORMATIVO DEI BENEFICIARI (SUL TOTALE DEGLI ADERENTI)',
        tooltip:
            'Il grafico mostra il tasso di attivazione dei beneficiari, complessivo e per ciascuna delle tipologie di attivazione (inserimento nel mercato del lavoro e ripresa degli studi), per il vostro progetto a confronto con la media degli stessi valori in tutti i progetti. I valori sono ottenuti rispettivamente dal rapporto tra: i giovani NEET complessivamente (re)inseriti in percorsi formativi o lavorativi (somma tra i NEET inseriti nel mercato del lavoro e i NEET che hanno ripreso gli studi), secondo la più recente scheda aggiornamento attività di intercettazione, e i giovani NEET in possesso dei requisiti richiesti dal bando che hanno aderito al progetto, firmando il documento di adesione, secondo la stessa scheda.',
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: [FUNNEL_KEYS_500.lavoro, FUNNEL_KEYS_500.studi]},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.aderito},
    },
    {
        key: 'ind_1_6',
        roman: '1.6',
        title: 'TASSO DI (RE)INSERIMENTO FORMATIVO/LAVORATIVO DEI BENEFICIARI (SUL TOTALE DEGLI INTERCETTATI)',
        tooltip: DASHBOARD1_SECTION_VI_TOOLTIP,
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.lavoro},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.coinvolti},
    },
    {
        key: 'ind_1_7',
        roman: '1.7',
        title: 'TASSO DI (RE)INSERIMENTO FORMATIVO/LAVORATIVO DEI BENEFICIARI (SUL TOTALE DEGLI INTERCETTATI)',
        tooltip: DASHBOARD1_SECTION_VI_TOOLTIP,
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.studi},
        denominator: {survey_id: survey500, question: FUNNEL_KEYS_500.coinvolti},
    },
    {
        key: 'ind_1_8',
        roman: '1.8',
        title: 'TASSO DI (RE)INSERIMENTO FORMATIVO/LAVORATIVO DEI BENEFICIARI RISPETTO ALLE PREVISIONI',
        tooltip: DASHBOARD1_SECTION_VII_TOOLTIP,
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.lavoro},
        denominator: {survey_id: survey499, question: FUNNEL_KEYS_499.p_lavoro},
    },
    {
        key: 'ind_1_9',
        roman: '1.9',
        title: 'TASSO DI (RE)INSERIMENTO FORMATIVO/LAVORATIVO DEI BENEFICIARI RISPETTO ALLE PREVISIONI',
        tooltip: DASHBOARD1_SECTION_VII_TOOLTIP,
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {survey_id: survey500, question: FUNNEL_KEYS_500.studi},
        denominator: {survey_id: survey499, question: FUNNEL_KEYS_499.p_studi},
    },
];

export const DASHBOARD2_TOOLTIP =
    'I box mostrano l’andamento dei percorsi dei beneficiari giovani NEET - suddivisi per percorsi in corso, percorsi abbandonati durante la fase di riattivazione, percorsi abbandonati durante la fase di reinserimento formativo e/o inserimento lavorativo, percorsi abbandonati – come quota di ciascuno stato di avanzamento sul totale dei percorsi avviati all’interno del vostro progetto, a confronto con le quote degli stessi valori in tutti i progetti. Il valore è ottenuto dal rapporto tra il valore medio di beneficiari che si trovano in una certa fase del proprio percorso progettuale, secondo la più recente scheda di aggiornamento beneficiari, e il totale dei giovani NEET intercettati per cui sia stata compilata la scheda beneficiari iniziale. Un beneficiario senza alcun aggiornamento inviato, o con un aggiornamento inviato solo parzialmente (quindi non conteggiato), è considerato con percorso ancora in corso (AP22/AP24R22).';

// The three mutually-exclusive "No, ..." values of question2 that mark a beneficiary's path as
// no-longer-in-corso — shared between the individual 2.2/2.3/2.4 slugs and the union slug used to
// derive 2.1 as a complement, so the two representations of "not in corso" cannot drift apart.
const RIATTIVAZIONE_ABBANDONATA = 'No, il/la beneficiario/a ha abbandonato il progetto durante la fase di riattivazione personale e sociale';
const REINSERIMENTO_ABBANDONATO = 'No, il/la beneficiario/a ha abbandonato il progetto durante la fase di reinserimento formativo e/o inserimento lavorativo';
const CONCLUSO_PREVISIONI = 'No, il percorso si è già concluso secondo le previsioni iniziali';

export const buildDashboard2Slugs = (survey501: number, survey502: number): ZeroNeetSurveySlug[] => [
    {
        // Union of the three "No, ..." answers below — every beneficiary whose path is *not* in
        // corso. Dashboard2 renders 2.1 ("Percorsi in corso") as 100 minus this single ratio
        // (computed once, at full precision, by the backend) rather than summing three already-
        // rounded percentages. Not rendered as its own NumericPair.
        key: 'ind_2_1_not_in_corso',
        title: 'Percorsi non più in corso (interno)',
        tooltip: DASHBOARD2_TOOLTIP,
        operation: 'match',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {
            survey_id: survey502,
            question: 'question2',
            value: [RIATTIVAZIONE_ABBANDONATA, REINSERIMENTO_ABBANDONATO, CONCLUSO_PREVISIONI],
        },
        denominator: {survey_id: survey501},
    },
    {
        key: 'ind_2_2',
        roman: '2.2',
        title: 'Percorsi abbandonati durante la fase di riattivazione',
        tooltip: DASHBOARD2_TOOLTIP,
        operation: 'match',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {
            survey_id: survey502,
            question: 'question2',
            value: [RIATTIVAZIONE_ABBANDONATA],
        },
        denominator: {survey_id: survey501},
    },
    {
        key: 'ind_2_3',
        roman: '2.3',
        title: 'Percorsi abbandonati durante la fase di reinserimento formativo e/o inserimento lavorativo',
        tooltip: DASHBOARD2_TOOLTIP,
        operation: 'match',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {
            survey_id: survey502,
            question: 'question2',
            value: [REINSERIMENTO_ABBANDONATO],
        },
        denominator: {survey_id: survey501},
    },
    {
        key: 'ind_2_4',
        roman: '2.4',
        title: 'Percorsi conclusi secondo le previsioni iniziali',
        tooltip: DASHBOARD2_TOOLTIP,
        operation: 'match',
        perParentUoa: true,
        perUoaLatest: true,
        poolAverage: true,
        numerator: {
            survey_id: survey502,
            question: 'question2',
            value: [CONCLUSO_PREVISIONI],
        },
        denominator: {survey_id: survey501},
    },
];

export const DASHBOARD3_AGGREGATE_TOOLTIP =
    'Il grafico mostra il numero di enti che si prevede di coinvolgere nell’ambito delle collaborazioni attivate dal vostro progetto, a confronto con la media dello stesso valore in tutti i progetti, secondo la scheda iniziale di rilevazione delle modalità di collaborazione.';

export const DASHBOARD3_NATURE_TOOLTIP =
    'I box numerici mostrano la composizione degli enti che si prevede di coinvolgere nella collaborazione, distinti per natura giuridica, per il vostro progetto a confronto con la media degli stessi valori in tutti i progetti e suddivisi per finalità principale della collaborazione. I valori sono ottenuti dal rapporto tra il numero di enti pubblici, enti privati non profit ed enti privati for profit effettivamente coinvolti e il numero complessivo di enti effettivamente coinvolti nella collaborazione, suddivisi per finalità.';

const NATURES: {code: keyof typeof ENTI_KEYS_504; indicatorNumber: string; roman: string; label: string}[] = [
    {code: 'pub', indicatorNumber: '2', roman: '3.2', label: 'Numero di enti pubblici che si prevede di coinvolgere'},
    {code: 'np', indicatorNumber: '3', roman: '3.3', label: 'Numero di enti privati non profit che si prevede di coinvolgere'},
    {code: 'fp', indicatorNumber: '4', roman: '3.4', label: 'Numero di enti privati for profit che si prevede di coinvolgere'},
];

export const buildDashboard3Slugs = (survey504: number): ZeroNeetSurveySlug[] => {
    const aggregate: ZeroNeetSurveySlug = {
        key: 'ind_3_1',
        roman: '3.1',
        title: 'Numero di enti che si prevede di coinvolgere',
        tooltip: DASHBOARD3_AGGREGATE_TOOLTIP,
        operation: 'sum',
        perParentUoa: true,
        perUoaLatest: true,
        isCount: true,
        numerator: {survey_id: survey504, question: 'domanda5'},
        denominator: {constant: 1},
    };

    const natureSlugs: ZeroNeetSurveySlug[] = (Object.keys(FINALITA) as (keyof typeof FINALITA)[]).flatMap((finKey) =>
        NATURES.map(({code, indicatorNumber, roman, label}) => ({
            key: `ind_3_${indicatorNumber}_${finKey}`,
            roman,
            title: label,
            tooltip: DASHBOARD3_NATURE_TOOLTIP,
            operation: 'sum' as const,
            perParentUoa: true,
            perUoaLatest: true,
            poolAverage: true,
            isCount: false,
            numerator: {survey_id: survey504, question: ENTI_KEYS_504[code]},
            denominator: {survey_id: survey504, question: 'domanda5'},
            filter: {question: 'question3', value: FINALITA[finKey]},
        })),
    );

    return [aggregate, ...natureSlugs];
};
